import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Select } from "@/components/common";
import { Check, Confirm, toggle } from "./shared";

const STATES = [{ value: "active", label: "Actif" }, { value: "hidden", label: "Masqué du menu" }, { value: "disabled", label: "Désactivé (accès refusé)" }];

export default function AdminModules() {
  const { settings, refreshUser } = useAuth();
  const [rows, setRows] = useState([]);
  const [ask, setAsk] = useState(false);
  useEffect(() => { let live = true; api.get("/admin/modules").then((r) => live && setRows(r.data)); return () => { live = false; }; }, []);
  const set = (code, k, v) => setRows(rows.map((r) => (r.code === code ? { ...r, [k]: v } : r)));
  const changed = rows.filter((r) => r.state !== "active" || r.disabled_companies.length).length;
  const save = async () => {
    try {
      await api.put("/admin/modules", { modules: Object.fromEntries(rows.map((r) => [r.code, { state: r.state, disabled_companies: r.disabled_companies }])) });
      toast.success("Modules enregistrés"); setAsk(false); refreshUser();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card space-y-4 p-6">
      <div className="flex flex-wrap items-center justify-between gap-2"><p className="text-sm text-[#6B6B80]">Un module désactivé disparaît du menu et ses accès serveur renvoient une erreur 403 (sauf pour le super admin). Un module masqué disparaît seulement du menu.</p>
        <button className="btn-primary" onClick={() => setAsk(true)} data-testid="modules-save-btn">Enregistrer</button></div>
      <div className="overflow-x-auto"><table className="w-full text-sm" data-testid="modules-table">
        <thead><tr className="border-b border-[#E4E4EC] text-left"><th className="py-2">Module</th><th className="py-2">État global</th><th className="py-2">Désactivé pour les sociétés</th></tr></thead>
        <tbody>{rows.map((r) => <tr key={r.code} className="border-b border-[#E4E4EC]">
          <td className="py-2 font-semibold">{r.label}</td>
          <td className="w-60 py-2"><Select value={r.state} onChange={(v) => set(r.code, "state", v)} options={STATES} testid={`module-state-${r.code}`} /></td>
          <td className="py-2"><div className="flex flex-wrap gap-3">{(settings?.companies || []).map((c) => <label key={c.code} className="flex items-center gap-1 text-xs"><Check checked={r.disabled_companies.includes(c.code)} onChange={(on) => set(r.code, "disabled_companies", toggle(r.disabled_companies, c.code, on))} testid={`module-${r.code}-company-${c.code}`} />{c.code}</label>)}</div></td>
        </tr>)}</tbody>
      </table></div>
      <Confirm open={ask} onClose={() => setAsk(false)} title="Appliquer la configuration des modules" count={changed} message="Modules masqués, désactivés ou restreints par société. Les utilisateurs concernés perdront l'accès immédiatement." danger={false} onConfirm={save} testid="modules-confirm" />
    </div>
  );
}
